<smatchy-header-back></smatchy-header-back>

<!-- The page had no title, unlike the search page it opens from. Same
     component and markup as that title (zone 2 review, 29/10/2026). -->
<header class="px-4 relative">
  <smatchy-title mode="end" class="ex-title">{{ 'SEARCH_CITY_PAGE.TITLE' | translate }}</smatchy-title>
</header>
<div class="absolute left-0 right-0 top-0 -z-10 w-full">
  <img src="assets/images/waves/wave_search.svg" alt="wave" class="w-full" />
</div>
<ion-content class="ion-padding">
  <smatchy-search-city-content
    [rayon]="rayon"
    [formattedAddress]="formattedAddress"
    [country]="country"
    [city]="city"
    [region]="region"
    [lat]="lat"
    [lng]="lng"
    [saveUser]="saveUser"
    (saved)="onSaved($event)"
  ></smatchy-search-city-content>
</ion-content>
